/**
 * Enhances plugin-purchase.liquid. Variants are native radio inputs, so the
 * form works without this script; Shopify owns submission, cart and checkout.
 */
class PluginPurchase extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    const source = this.querySelector('[data-plugin-variants]');
    this.inputs = [...this.querySelectorAll('[data-plugin-variant]')];
    if (!source || !this.inputs.length) return;
    try {
      this.variants = JSON.parse(source.textContent);
    } catch {
      return; // The server-rendered form remains fully usable.
    }
    this.controller = new AbortController();
    for (const input of this.inputs) {
      input.addEventListener('change', () => this.update(true), { signal: this.controller.signal });
    }
    this.update(false);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }

  selected() {
    const input = this.inputs.find((item) => item.checked);
    return input ? this.variants.find((variant) => variant.id === input.value) : undefined;
  }

  update(fromUser) {
    const variant = this.selected();
    const button = this.querySelector('[data-plugin-submit]');
    const label = this.querySelector('[data-plugin-submit-label]');
    const price = this.querySelector('[data-plugin-price]');
    const note = this.querySelector('[data-plugin-launch-note]');
    const quantity = this.querySelector('[data-plugin-quantity]');

    if (button) button.disabled = !variant?.available;
    if (label) {
      label.textContent = variant?.available ? variant.label
        : variant ? this.dataset.soldOutLabel : this.dataset.unavailableLabel;
    }
    if (price) price.textContent = variant?.price ?? '';
    if (note) note.hidden = !variant?.isLaunch;

    if (quantity && variant) {
      quantity.min = String(variant.min);
      quantity.step = String(variant.step);
      if (variant.max !== null && variant.max !== undefined) quantity.max = String(variant.max);
      else quantity.removeAttribute('max');
      if (fromUser) quantity.value = String(variant.min);
    }

    if (fromUser && variant) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      url.searchParams.delete('option_values');
      // Keep development-theme previews, alternate views, locale paths and hash.
      window.history.replaceState(window.history.state, '', url);
    }
  }
}

if (!customElements.get('plugin-purchase')) {
  customElements.define('plugin-purchase', PluginPurchase);
}
